import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'fal-regional-helpline',
  templateUrl: './regional-helplines.component.html',
  styleUrls: ['./regional-helplines.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegionalHelplinesComponent {
  @Input() heading: string;
  @Input() phoneNumbers: { heading?: string; phone: string }[] = [];
}
